import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SellHeroSection from './components/SellHeroSection';
import UnderstandingGoalsSection from './components/UnderstandingGoalsSection';
import ProcessSection from './components/ProcessSection';
import ExpectationsSection from './components/ExpectationsSection';
import FAQSection from './components/FAQSection';
import SellCTASection from './components/SellCTASection';

const SellBusinessPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <SellHeroSection />
        <UnderstandingGoalsSection />
        <ProcessSection />
        <ExpectationsSection />
        <FAQSection />
        <SellCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default SellBusinessPage;
